<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--mypage is-hide">
            <header class="l-header l-header--top">
                <public-page-header />
            </header>

            <section class="l-content-area">
                <div class="l-content">
                    <section class="p-bloc p-bloc--mypage">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">
                                <section class="p-mypage">
                                    <div class="p-mypage__content">
                                        <div class="mypage-content">
                                            <div class="p-mypage__page mypage-bloc">
                                                <div class="mypage-bloc__content">
                                                    <div class="page__bloc page__bloc--terms c-kiyaku">
                                                        <div class="blog-page">
                                                            <article id="post-inner">
                                                                <header class="article-header">
                                                                    <h1>セイコーマートでのお支払い方法について</h1>
                                                                    <ul class="post-data">
                                                                        <li class="posted"><span
                                                                                class="data-h">POSTED&nbsp;:&nbsp;&nbsp;</span>2014.01.20
                                                                        </li>
                                                                    </ul>
                                                                    <sns-share-links />

                                                                    <div class="eyecatch-img">
                                                                        <span>
                                                                            <img width="860" height="480"
                                                                                src="@/assets/img/static_pages/seicomart_eyecatch1.png"
                                                                                class="attachment-w860-h480 size-w860-h480 wp-post-image"
                                                                                alt="convenience-payment-method">
                                                                        </span>
                                                                    </div>
                                                                </header>

                                                                <!-- post -->
                                                                <section class="article-content">
                                                                    <p>hubsynchでは、コンビニ決済をご利用いただけます。 </p>
                                                                    <p>こちらは、セイコーマート店舗を利用したお支払い方法の説明です。</p>
                                                                    <h4>お支払いの際に必要となるもの</h4>
                                                                    <p>お支払いの際には、「お支払い受付番号（6桁）」と「電話番号」が必要になります。</p>

                                                                    <h4>お支払い方法</h4>
                                                                    <p>セイコーマート店舗内に設置されているクラブステーション端末を操作していただきます。</p>
                                                                    <p>また、お支払い後に「領収書」を忘れずにお受取りください。</p>
                                                                    <p>※お支払い方法の各画面等は、実際の画面とは若干異なる場合がございます。予めご了承ください。</p>


                                                                    <h4>ステップ1</h4>
                                                                    <p>クラブステーション端末のトップ画面で「インターネット受付」を選択してください。</p>

                                                                    <p style="text-align: center;"><img
                                                                            class="aligncenter size-full wp-image-659"
                                                                            src="@/assets/img/static_pages/seicomart.jpg"
                                                                            width="500" height="350"></p>
                                                                    <h4>ステップ2</h4>
                                                                    <p>「お支払い受付番号（6桁）」入力し、「次へすすむ」を押してください。</p>
                                                                    <p style="text-align: center;"><img
                                                                            class="aligncenter size-full wp-image-660"
                                                                            alt="seicomart"
                                                                            src="@/assets/img/static_pages/seicomart-2.jpg"
                                                                            width="500" height="350"></p>
                                                                    <h4>ステップ3</h4>
                                                                    <p>hubsynchに登録しているお客様の「電話番号」を入力し、「次へすすむ」を押してください。
                                                                    </p>
                                                                    <p style="text-align: center;"><img
                                                                            class="aligncenter size-full wp-image-661"
                                                                            alt="seicomart"
                                                                            src="@/assets/img/static_pages/seicomart-3.jpg"
                                                                            width="500" height="350"></p>
                                                                    <h4>ステップ4</h4>
                                                                    <p>問合せ中画面が表示されます。</p>
                                                                    <p style="text-align: center;"><img
                                                                            class="aligncenter size-full wp-image-662"
                                                                            alt="seicomart"
                                                                            src="@/assets/img/static_pages/seicomart-4.jpg"
                                                                            width="500" height="350"></p>
                                                                    <h4>ステップ5</h4>
                                                                    <p>お客様のお申込内容が表示されますので、内容ご確認後、よろしければ「印刷」を押してください。
                                                                    </p>
                                                                    <p style="text-align: center;"><img
                                                                            class="aligncenter size-full wp-image-663"
                                                                            alt="seicomart"
                                                                            src="@/assets/img/static_pages/seicomart-5.jpg"
                                                                            width="500" height="350"></p>
                                                                    <h4>ステップ6</h4>
                                                                    <p>端末から申込券（計3枚）が発券されます。申込券3枚を持って30分以内にレジにてお支払いください。お支払い後、領収書を忘れずにお受取りください。
                                                                    </p>
                                                                    <p style="text-align: center;"><img
                                                                            class="aligncenter size-full wp-image-663"
                                                                            alt="seicomart"
                                                                            src="@/assets/img/static_pages/seicomart-6.jpg"
                                                                            width="500" height="350"></p>
                                                                    <h4>ご注意事項</h4>
                                                                    <p>コンビニエンスストア店舗では、30万円を超えるお支払いはできません。</p>
                                                                    <p>ご注文内容に関するお問合せは、お申込をされたショップ（ご購入元）へお問合せください。</p>
                                                                    <p>コンビニエンスストア店舗では、ご注文内容の変更・取消および返金はできません。</p>
                                                                    <div id="btn-contact-wrap"
                                                                        class="btn-wrap company-contact-cta">
                                                                        <p class="txt">ご不明な点がございましたら、お問合せフォームからご連絡ください。
                                                                        </p>
                                                                        <p class="btn"><a href="/contactus"
                                                                                style="color: #fff !important;">お問合せ</a>
                                                                        </p>
                                                                    </div>
                                                                </section>
                                                            </article>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
            <Footer v-if="isLoggedIn"/>
            <PublicFooter v-else/>
        </div>
    </div>

</template>
<script setup>
import PublicPageHeader from "@/components/PublicPageHeader.vue";
import SnsShareLinks from "@/components/SnsShareLinks.vue";
import { ref, onBeforeMount } from "vue";
import { useSessionStore } from "@/stores/sessionStore";
import Footer from "@/components/Footer.vue";
import PublicFooter from "@/components/PublicFooter.vue";

const sessionStore = useSessionStore();
const isLoggedIn = ref(false);
onBeforeMount(async () => {
    isLoggedIn.value = sessionStore.isLoggedIn();
});
</script>